/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { OverviewProps } from './overview.types';
import { styles } from './themes/VisOverview.css';

export function OverviewBackground({
  x,
  width,
  height,
  y,
  windowX,
  windowHeight,
  windowWidth,
  windowY
}: OverviewProps) {
  return (
    <>
      <rect
        x={x}
        y={y}
        width={Math.max(0, windowX - x)}
        height={height}
        class={styles.overviewBackground}></rect>

      <rect
        x={windowX + windowWidth}
        width={Math.max(0, x + width - windowX - windowWidth)}
        y={y}
        height={height}
        class={styles.overviewBackground}></rect>

      <rect
        x={windowX}
        y={y}
        height={Math.max(0, windowY - y)}
        width={windowWidth}
        class={styles.overviewBackground}></rect>

      <rect
        x={windowX}
        y={windowY + windowHeight}
        width={windowWidth}
        class={styles.overviewBackground}
        height={Math.max(y + height - windowY - windowHeight, 0)}></rect>
    </>
  );
}
